export default "__VITE_ASSET__nEdopGaP__"